import axios from "axios";
import baseStore from "./base";
import atualizarDadosProduto from "@/atualizar_dados_produto";
import sistemaStore from "./sistema";
import moment from "moment/moment";
import {
  getConfigPedidosDB,
  getPedidosDB,
  getProdutosDB,
  removerPedidoDB,
  saveProdutos,
} from "@/db/pedidos";
import insumosStore from "./insumos";

const getDefaultState = () => {
  return {
    pedidos: [],
    status: [],
    novopedido: {
      usuario: null,
      filial: 0,
      tipoPedidoSelec: 0,
      tipopedido: null,
      cliente: null,
      freteporconta: "Comprador",
      dtentrega: moment().format("YYYY-MM-DD"),
      condicaoPgtoSelecionada: 0,
      condicaopgto: null,
      parcelaSelecionada: 1,
      vctoinicial: moment().add(1, "days").format("YYYY-MM-DD"),
      contaSelecionada: "",
      parcelas: [],
      produtos: [],
      observacao: "",
      assinatura: "",
      emitiupedido: false,
      datahoraemissao: "",
      datahoravalidade: "",
      tipocartaoselec: "Credito",
      cartaoSelecionado: 0,
    },
    config: null,
    produtos: [],
    dialogProdutos: false,
    produtoSelecionado: null,
    adicionando: false,
    dialogAssinatura: false,
    vendedorSaldo: 0,
    syncPedidos: false,
    tiposPedidoEmissao: [
      { opcao: "Ração", rota: "/novo-pedido", rotaPedidos: "/central-pedidos" },
      {
        opcao: "Insumos/Veterinária",
        rota: "/novo-pedido-insumos",
        rotaPedidos: "/central-pedidos-insumos",
      },
    ],
  };
};

const pedidosStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setPedidos(state, pedidos) {
      state.pedidos = pedidos;
    },
    setStatus(state, status) {
      state.status = status;
    },
    setConfigPedidos(state, cfg) {
      state.config = cfg;
    },
    setProdutos(state, prods) {
      state.produtos = prods;
    },
    setDialogProdutos(state, value) {
      state.dialogProdutos = value;
    },
    setProdutoSelecionado(state, value) {
      state.produtoSelecionado = value;
      state.produtoSelecionado.parcelas = [];
    },
    setDialogAssinatura(state, value) {
      state.dialogAssinatura = value;
    },
    setNovoPedido(state, value) {
      state.novopedido = value;
    },
    setVendedorSaldo(state, value) {
      state.vendedorSaldo = value;
    },
  },
  actions: {
    atualizarDadosProduto,
    async salvarPedido(context) {
      try {
        var res = await axios.post(
          "/nutricao-animal/pedidos/salvar-pedido",
          JSON.stringify(context.state.novopedido)
        );

        if (res.data.success) {
          context.state.novopedido.emitiupedido = true;
          return res.data.data;
        } else {
          return { id: 0, msg: res.data.msg };
        }
      } catch (error) {
        return { id: 0, msg: `Este erro impediu de salvar o pedido: ${error}` };
      }
    },
    async getPedidos(context, body) {
      context.commit("setPedidos", []);
      await axios
        .post("/nutricao-animal/pedidos/central-pedidos", JSON.stringify(body))
        .then((res) => {
          if (res.data.success) {
            context.commit("setPedidos", res.data.data);
          }
        });
    },
    async getStatusPedido(context) {
      context.commit("setStatus", []);
      await axios.get("/nutricao-animal/pedidos/status-pedido").then((res) => {
        if (res.data.success) {
          context.commit("setStatus", res.data.data);
        }
      });
    },
    async getConfigPedidos(context) {
      context.commit("setConfigPedidos", null);
      if (navigator.onLine) {
        await axios
          .get("/nutricao-animal/pedidos/config-pedidos")
          .then((res) => {
            if (res.data.success) {
              context.commit("setConfigPedidos", res.data.data);
            }
          });
      } else {
        var cfgPedidos = await getConfigPedidosDB();
        if (cfgPedidos.length > 0) {
          context.commit("setConfigPedidos", cfgPedidos[0]);
        }
      }
    },
    async getProdutos(context) {
      context.commit("setProdutos", []);
      var produtosDB = await getProdutosDB();
      if (navigator.onLine) {
        var params = {};
        if (produtosDB.length > 0) {
          params.sinc = produtosDB[0].dthoraultsinc;
        }

        await axios
          .get("/nutricao-animal/pedidos/buscar-produtos", {
            params: params,
          })
          .then(async (res) => {
            if (res.data.success) {
              if (res.data.data.length > 0) {
                await saveProdutos(res.data.data);
                produtosDB = await getProdutosDB();
              }
            }
          });
      }

      if (!sistemaStore.state.sincronizando) {
        context.commit(
          "setProdutos",
          produtosDB.filter(
            (p) => p.gp == context.getters.getFilialSelecionada.gp
          )
        );
        context.dispatch("atualizarDadosProduto");
      }
    },
    recalcularFrete(context) {
      context.state.adicionando = false;
      if (context.getters.cobrarFrete) {
        var valorPorKg = 0;
        context.state.novopedido.produtos.forEach((p) => {
          context.commit("setProdutoSelecionado", p);
          valorPorKg = context.getters.getValorFrete.valor_kg;
          p.valorfrete = valorPorKg * p.qtdekgs;     
          p.valorfreteton = context.getters.getValorFrete.valor_ton;     
          if (context.state.novopedido.cliente.vlrdescfrete > 0) {
            valorPorKg =
              valorPorKg - context.state.novopedido.cliente.vlrdescfrete / 1000;
            p.valorliqfrete = valorPorKg * p.qtdekgs;
          }

          p.valortotalitem =
            p.vlrunitario * p.qtde +
            (p.valorliqfrete > 0 ? p.valorliqfrete : p.valorfrete);
          p.vlrunitcomfrete = p.valortotalitem / p.qtde;
        });
      }
    },
    calcularProduto(context) {
      context.state.produtoSelecionado.valortotalitem = 0;
      context.state.produtoSelecionado.comissaoperc =
        context.state.produtoSelecionado.comissaomax -
        context.state.produtoSelecionado.percdesconto;
      if (context.state.produtoSelecionado.comissaoperc <= 0) {
        context.state.produtoSelecionado.comissaoperc = 0;
      }

      //Tive que fazer espelhamento para refletir no valor do frete
      context.state.produtoSelecionado = {
        ...context.state.produtoSelecionado,
        qtdekgs:
          context.state.produtoSelecionado.qtde *
          context.state.produtoSelecionado.qtdeemb,
      };

      context.state.produtoSelecionado.valorcalclista =
        context.state.produtoSelecionado.preco *
        context.state.produtoSelecionado.qtde;

      /*Calcular o desconto total do produto*/
      context.state.produtoSelecionado.valordesconto =
        (context.state.produtoSelecionado.valorcalclista *
          context.state.produtoSelecionado.percdesconto) /
        100;

      /*Atualizar valor unitário*/
      context.state.produtoSelecionado.vlrunitario =
        (context.state.produtoSelecionado.valorcalclista -
          context.state.produtoSelecionado.valordesconto) /
        context.state.produtoSelecionado.qtde;

      /*Calcular os juros*/
      if (context.state.produtoSelecionado.acrescimoperc > 0) {
        if (context.getters.getTipoPedidoSelec.contrato) {
          var pAcresc = context.state.produtoSelecionado.acrescimoperc;
          if (context.getters.getCondicaoSelecionada.acrescimoperc > 0) {
            pAcresc = context.getters.getCondicaoSelecionada.acrescimoperc;
          }

          context.state.produtoSelecionado.vlrunitario =
            context.state.produtoSelecionado.vlrunitario +
            (pAcresc * context.state.produtoSelecionado.vlrunitario) / 100;
        } else {
          var valorTot = 0;
          context.getters.getParcelas.forEach((parc, i) => {
            var percCalc =
              parc.dias * (context.state.produtoSelecionado.acrescimoperc / 30);
            var vlrAcresc =
              (context.state.produtoSelecionado.vlrunitario * percCalc) / 100;
            valorTot +=
              context.state.produtoSelecionado.vlrunitario + vlrAcresc;
            context.state.produtoSelecionado.parcelas[i] = {
              parcela: `Parcela ${parc.parc}`,
              dias: parc.dias,
              perc: percCalc,
              vlr_acresc: vlrAcresc,
              vlr_total: valorTot,
            };
          });
          context.state.produtoSelecionado.vlrunitario =
            valorTot / context.state.produtoSelecionado.numparcelas;
        }
      }

      /*Calcular tributação*/
      if (context.state.produtoSelecionado.perctributaforauf > 0) {
        context.state.produtoSelecionado.vlrunitario +=
          (context.state.produtoSelecionado.vlrunitario *
            context.state.produtoSelecionado.perctributaforauf) /
          100;
      }

      if (context.state.produtoSelecionado.perctributadiferimento > 0) {
        context.state.produtoSelecionado.vlrunitario +=
          (context.state.produtoSelecionado.vlrunitario *
            context.state.produtoSelecionado.perctributadiferimento) /
          100;
      }

      /*Calcular Frete*/
      if (context.getters.cobrarFrete) {
        context.state.adicionando = true;

        var dadosFrete = context.getters.getValorFrete

        context.state.produtoSelecionado.valorfrete =
        dadosFrete.valor_kg *
          context.state.produtoSelecionado.qtdekgs;

        context.state.produtoSelecionado.valorfreteton = dadosFrete.valor_ton

        if (context.state.novopedido.cliente.vlrdescfrete > 0) {
          context.state.produtoSelecionado.valorliqfrete =
            (dadosFrete.valor_kg -
              context.state.novopedido.cliente.vlrdescfrete / 1000) *
            context.state.produtoSelecionado.qtdekgs;
        }
      }
      
      if (isNaN(context.state.produtoSelecionado.vlrunitario)) {
        context.state.produtoSelecionado.vlrunitario = 0;
        context.state.produtoSelecionado.valortotalitem = 0;
        context.state.produtoSelecionado.vlrunitcomfrete = 0;
      } else {
        context.state.produtoSelecionado.valortotalitem =
          context.state.produtoSelecionado.vlrunitario *
          context.state.produtoSelecionado.qtde;

        /*Se for pgto no cartão preciso embutir o preço dos juros no preço de lista -Solicitado: Adriano*/
        if (
          context.getters.getCondicaoSelecionada.cartao &&
          context.state.novopedido.cartaoSelecionado > 0
        ) {
          var txJuros = context.getters.getTxJuros;
          if (txJuros > 0) {
            context.state.produtoSelecionado.valortotalitem +=
              (context.state.produtoSelecionado.valortotalitem * txJuros) / 100;
            context.state.produtoSelecionado.vlrunitario =
              context.state.produtoSelecionado.valortotalitem /
              context.state.produtoSelecionado.qtde;
          }
        }

        context.state.produtoSelecionado.valortotalitem +=
          context.state.produtoSelecionado.valorliqfrete > 0
            ? context.state.produtoSelecionado.valorliqfrete
            : context.state.produtoSelecionado.valorfrete;

        context.state.produtoSelecionado.vlrunitcomfrete =
          context.state.produtoSelecionado.valortotalitem /
          context.state.produtoSelecionado.qtde;
      }
    },
    async sincronizarPedidos(state) {
      state.syncPedidos = true;

      const dbsSync = ["pedidos", "pedidos-insumos"];
      for (const db_off of dbsSync) {
        var pedidosSync = await getPedidosDB(db_off);
        for (const ped of pedidosSync) {
          if (moment().isAfter(moment(ped.datahoravalidade))) {
            await removerPedidoDB(ped.id_db, db_off);
          } else {
            var resPed = { id: 0 };
            if (db_off == "pedidos") {
              state.novopedido = ped;
              resPed = await this.salvarPedido(pedidosStore);
            } else {
              insumosStore.state.lista_itens = [];
              for (const item of ped.itens) {
                insumosStore.state.lista_itens.push(item);
              }
              var res = await insumosStore.actions.salvarPedido(insumosStore);
              if (res.status == 200) {
                resPed.id = res.data.pedido;
              }
            }

            if (resPed.id > 0) {
              await removerPedidoDB(ped.id_db, db_off);
            }
          }
        }
      }
      state.syncPedidos = false;
    },
  },
  getters: {
    getDataEntrega(state) {
      try {
        return state.config.entregas.find(
          (e) => moment().isAfter(e.horaini) && moment().isBefore(e.horafim)
        ).data;
      } catch (error) {
        return "";
      }
    },
    clienteBloqueado(state) {
      try {
        return (
          state.novopedido.cliente.mensagens.findIndex((msg) => msg.bloquear) >=
          0
        );
      } catch (error) {
        return false;
      }
    },
    getCondicaoSelecionada(state) {
      return state.config.condicoespgto.find(
        (c) => c.codigo == state.novopedido.condicaoPgtoSelecionada
      );
    },
    getParcelas(state, getters) {
      try {
        if (state.novopedido.cliente.bloq_vendas_prazo) {
          return getters.getCondicaoSelecionada.vencimentos.filter(
            (v) =>
              v.data == state.novopedido.vctoinicial &&
              v.parc <= state.novopedido.parcelaSelecionada &&
              v.libera_cliente_bloq
          );
        }
        return getters.getCondicaoSelecionada.vencimentos.filter(
          (v) =>
            v.data == state.novopedido.vctoinicial &&
            v.parc <= state.novopedido.parcelaSelecionada
        );
      } catch (error) {
        return [];
      }
    },
    getFilialSelecionada(state) {
      return baseStore.state.filiais.find(
        (f) => f.filial == state.novopedido.filial
      );
    },
    getContaSelecionada(state) {
      return state.config.contas.find(
        (c) => c.conta == state.novopedido.contaSelecionada
      );
    },
    getTipoPedidoSelec(state) {
      return state.config.tipospedido.find(
        (tp) => tp.codigo == state.novopedido.tipoPedidoSelec
      );
    },
    cobrarFrete(state) {
      return state.novopedido.freteporconta.toLowerCase() == "comprador";
    },
    getValorFrete(state, getters) {
      if (getters.cobrarFrete) {
        var listaProdutos = [];
        state.novopedido.produtos.forEach((p) => {
          listaProdutos.push(p);
        });

        if (state.adicionando) {
          listaProdutos.push(state.produtoSelecionado);
        }

        var valorPorTon = 0;
        var pesoMaxRecalc = state.novopedido.cliente.peso_max_recalc_frete;
        var vlrFreteUtilizar = state.novopedido.cliente.vlrfretepadrao;
        if (state.novopedido.cliente.outrosfretes.length > 0) {
          for (let frete of state.novopedido.cliente.outrosfretes) {
            var indPosFrete = listaProdutos.findIndex(
              (p) => p.embfrete == frete.embfrete
            );

            if (indPosFrete >= 0) {
              vlrFreteUtilizar = frete.valor;
              pesoMaxRecalc = frete.peso_max_recalc_frete;
              break;
            }
          }
        }

        valorPorTon = vlrFreteUtilizar;

        /*Só considerar granel*/
        if (state.produtoSelecionado.embfrete == 1) {
          if (
            pesoMaxRecalc > 0 &&
            state.produtoSelecionado.qtdekgs > 0 &&
            pesoMaxRecalc >= state.produtoSelecionado.qtdekgs
          ) {
            valorPorTon = (vlrFreteUtilizar * pesoMaxRecalc) / 1000;

            vlrFreteUtilizar =
              (vlrFreteUtilizar * pesoMaxRecalc) /
              state.produtoSelecionado.qtdekgs;            
          }
        }

        return {
          valor_kg: vlrFreteUtilizar / 1000,
          valor_ton: valorPorTon,
        };
      }
      return 0;
    },
    selecionouProdutoSaldoContrato(state) {
      return state.novopedido.produtos.findIndex((p) => p.saldofutura > 0) >= 0;
    },
    getQtdeTotalKgsPedido(state) {
      var qtdeTotalKgs = 0;
      state.novopedido.produtos.forEach((ped) => {
        qtdeTotalKgs += ped.qtdekgs;
      });
      return qtdeTotalKgs;
    },
    async getSaldoUsadoContrato(state) {
      var saldoUsadoContrato = 0;
      var pedidosDB = await getPedidosDB("pedidos");

      if (pedidosDB.length > 0) {
        pedidosDB.forEach((p) => {
          if (p.cliente.vendedor.cod == state.vendedorSaldo) {
            p.produtos.forEach((prod) => {
              saldoUsadoContrato += prod.qtdekgs;
            });
          }
        });
      }
      return saldoUsadoContrato;
    },
    async validarEmissaoPedido(state, getters) {    
      if (state.novopedido.emitiu) {
        return {
          erro: true,
          msg: "Pedido já emitido. É necessário reatualizar a página para emitir um novo pedido",
        };
      } else if (
        state.novopedido.produtos.findIndex((p) => p.precisaretirar) >= 0 &&
        !getters.getTipoPedidoSelec.remessa
      ) {
        return {
          erro: true,
          msg: "Pedido possui item(ns) com retirada obrigatória. É necessário retirar todo o produto antes de emitir um pedido de venda!",
        };
      } else if (
        getters.getTipoPedidoSelec.assinatura_obrigatoria &&
        state.novopedido.assinatura == ""
      ) {
        return {
          erro: true,
          msg: `Este tipo de pedido só pode ser emitido com a assinatura do cliente!`,
        };
      } else {
        if (
          getters.getTipoPedidoSelec.contrato &&
          state.novopedido.cliente.vendedor.validar_saldo
        ) {
          state.vendedorSaldo = state.novopedido.cliente.vendedor.cod;
          var saldoUsado = await getters.getSaldoUsadoContrato;
          var saldoDisp =
            state.novopedido.cliente.vendedor.saldo_emis_contrato - saldoUsado;
          if (saldoDisp - getters.getQtdeTotalKgsPedido <= 0) {
            return {
              erro: true,
              msg: `Vendedor não possui saldo suficiente para emitir pedidos do tipo CONTRATO! Kgs pedido: ${getters.getQtdeTotalKgsPedido} / Kgs disponível: ${saldoDisp}.`,
            };
          }
        }
      }

      return {
        erro: false,
        msg: "",
      };
    },
    getTxJuros(state) {
      if (state.novopedido.cartaoSelecionado > 0) {
        return state.config.cartoes.find(
          (c) => c.cod == state.novopedido.cartaoSelecionado
        ).txjuros;
      }

      return 0;
    },
  },
};

export default pedidosStore;
